import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MediaUpload from '~/components/common/media-upload';
import Icon from '~/components/common/icon';

/**
 * Render Classic Question Type
 * - single
 * - multiple
 * - sort
 *
 * @callback handleAnswerRemove
 * @callback handleAnswerUpdate
 * @callback handleCheckboxChange
 * @callback handleInputChange
 * @callback handleShowForm
 * @callback handleAddMedia
 * @callback handleCorrectChange
 * @param {Object} props
 * @param {handleAnswerRemove} props.handleAnswerUpdate
 * @param {handleAnswerUpdate} props.handleAnswerRemove
 * @param {handleCheckboxChange} props.handleCheckboxChange
 * @param {handleInputChange} props.handleInputChange
 * @param {handleShowForm} props.handleShowForm
 * @param {handleAddMedia} props.handleAddMedia
 * @param {handleCorrectChange} props.handleCorrectChange
 * @param {string} props.questionType
 * @param {number} props.questionID
 * @param {number} props.index
 * @param {boolean} props.showFormIndividual
 * @param {string} props.answer
 * @param {boolean} props.correct
 * @param {boolean} props.html
 */
const QuestionTypeClassic = ( {
	handleAnswerUpdate,
	handleAnswerRemove,
	handleCheckboxChange,
	handleInputChange,
	handleShowForm,
	handleAddMedia,
	handleCorrectChange,
	questionType,
	questionID,
	index,
	showFormIndividual,
	answer,
	correct,
	html,
} ) => (
	<Fragment>
		<span className="ld__builder-row-type -child sfwd-answer">A</span>
		{ ! showFormIndividual && (
			<button onClick={ handleShowForm } className="ld-button-reset">
				{ true === html ? (
					<span
						className={ `ld-answer-value ${
							correct ? '-correct' : ''
						}` }
						dangerouslySetInnerHTML={ {
							__html:
								'' === answer
									? `${ LearnDashData.i18n.edit_answer }`
									: answer,
						} }
					/>
				) : (
					<span
						className={ `ld-answer-value ${
							correct ? '-correct' : ''
						}` }
					>
						{ '' === answer
							? `${ LearnDashData.i18n.edit_answer }`
							: answer }
					</span>
				) }
				<span className="edit">
					<Icon icon="pencil" />
					<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
				</span>
			</button>
		) }
		{ showFormIndividual && (
			<div className="ld-answer-editor">
				<textarea
					name="answer"
					value={ answer }
					onChange={ handleInputChange }
					autoFocus
				/>
				<div className="ld-answer-editor-actions">
					<button
						className="is-button is-primary"
						onClick={ handleAnswerUpdate }
					>{ `${ LearnDashData.i18n.update_answer }` }</button>
					<span className="ld-trash">
						<button
							className="is-button components-button is-default"
							onClick={ handleShowForm }
						>{ `${ LearnDashData.i18n.cancel }` }</button>
					</span>
					<label className="ld-switch-wrapper html">
						<span className="ld-switch">
							<input
								type="checkbox"
								name="html"
								checked={ html }
								onChange={ handleCheckboxChange }
								className="ld-switch__input"
							/>
							<span className="ld-switch__track" />
							<span className="ld-switch__thumb" />
							<span className="ld-switch__on-off" />
						</span>
						<span className="label-text">{ `${ LearnDashData.i18n.allow_html }` }</span>
					</label>
					<MediaUpload onSelect={ handleAddMedia } />
				</div>
			</div>
		) }
		{ 'sort_answer' === questionType && (
			<div
				className="ld-radio-input-wrapper"
				style={ { marginRight: '10px' } }
			>
				<span
					dangerouslySetInnerHTML={ {
						__html: ( () => {
							switch ( parseInt( index + 1, 10 ) ) {
								case 1:
									return `${ LearnDashData.i18n.correct } ${ LearnDashData.i18n.correct_1st }`;
								case 2:
									return `${ LearnDashData.i18n.correct } ${ LearnDashData.i18n.correct_2nd }`;
								case 3:
									return `${ LearnDashData.i18n.correct } ${ LearnDashData.i18n.correct_3rd }`;
								default:
									return `${
										LearnDashData.i18n.correct
									} ${ parseInt( index + 1, 10 ) }${
										LearnDashData.i18n.correct_nth
									}`;
							}
						} )(),
					} }
				/>
			</div>
		) }
		{ 'sort_answer' !== questionType && ! showFormIndividual && (
			<span className="ld-radio-input-wrapper">
				<input
					className={
						'multiple' === questionType
							? 'ld-checkbox-input'
							: 'ld-radio-input'
					}
					type={ 'multiple' === questionType ? 'checkbox' : 'radio' }
					id={ `answer-${ index }-${ questionID }` }
					name={ `correct-answer-${ questionID }` }
					checked={ correct }
					onChange={ handleCorrectChange }
				/>
				<label
					className={
						'multiple' === questionType
							? 'ld-checkbox-input__label'
							: 'ld-radio-input__label'
					}
					htmlFor={ `answer-${ index }-${ questionID }` }
				>
					<span>{ `${ LearnDashData.i18n.correct }` }</span>
				</label>
			</span>
		) }
		<div className="row-actions">
			<span className="trash">
				<a
					href="#"
					className="submitdelete"
					onClick={ handleAnswerRemove }
				>{ `${ LearnDashData.i18n.remove }` }</a>
			</span>
		</div>
	</Fragment>
);
/**
 * Valid props
 */
QuestionTypeClassic.propTypes = {
	handleAnswerUpdate: PropTypes.func,
	handleAnswerRemove: PropTypes.func,
	handleCheckboxChange: PropTypes.func,
	handleInputChange: PropTypes.func,
	handleShowForm: PropTypes.func,
	handleAddMedia: PropTypes.func,
	handleCorrectChange: PropTypes.func,
	questionType: PropTypes.string,
	questionID: PropTypes.number,
	index: PropTypes.number,
	showFormIndividual: PropTypes.bool,
	answer: PropTypes.string,
	correct: PropTypes.bool,
	html: PropTypes.bool,
};

export default QuestionTypeClassic;
